import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0 fill-height",
    style: {"background-color":"#20242f"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "fill-height",
        align: "center",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                align: "center",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "text-center"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("h1", { class: "text-white" }, "Welcome to Damae's dermoscopy cloud", -1),
                      _createElementVNode("p", { class: "mt-3 text-white" }, " Please enter your credentials to access the platform. ", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "mt-5 text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                        label: "Password",
                        type: "password",
                        outlined: "",
                        dense: "",
                        class: "text-white",
                        onKeyup: _withKeys(_ctx.login, ["enter"])
                      }, null, 8, ["modelValue", "onKeyup"]),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        onClick: _ctx.login
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode(" Login ")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_snackbar, {
            modelValue: _ctx.showSnackbar,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showSnackbar) = $event)),
            color: _ctx.snackbarColor,
            timeout: "3000"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.snackbarMessage), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "color"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}